var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recover-password-greetings"},[_vm._m(0),_c('div',{staticClass:"aside"},[_c('router-link',{staticClass:"back-to-home--anchor",attrs:{"to":"/login"}},[_vm._v("Login")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recover-password--headings"},[_c('h2',{staticClass:"recover-password--title"},[_vm._v(" Cotraseña cambiada ")])])
}]

export { render, staticRenderFns }